import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const RadioEnum = ({ field, onChange, errors = {}, value, small = false }) => {
  const makeid=()=> {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  
    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
  
    return text;
  }
  const renderOptions = () => {
    let optionsToRender = [];
    for (let value in field.options) {
      if (value !== "") {
        optionsToRender.push(
          <FormControlLabel
            key={makeid()}
            value={value}
            control={<Radio color="primary" />}
            label={field.options[value]}
          />
        )
      }
    }
    return optionsToRender;
  };

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{field.label}{field.required === 'true' ? '*' : ''}</FormLabel>
      <RadioGroup
        row aria-label="position"
        name="position"
        defaultValue="top"
        onChange={(e) => onChange(e.target.value)}
        value={value}
      >
        {renderOptions()}
      </RadioGroup>
    </FormControl>
  );
}

export default RadioEnum;